import TranslationNS from '@/utils/Constants/TranslationNS'

const VOLUNTEERING = TranslationNS.VOLUNTEERING

/**
 * « Candidatures des volontaires » (`staff/orders`): the Orders engine with the volunteer audience.
 * Anchors: `vol-tiles` (VolunteerTiles), `sec-orders-list` / `orders-status` / `orders-search`
 * (shared OrdersListCard, anchored by the Athletes › Registrations tour); the table head and the pager
 * are reached through the list card's own classes. The application drawer and the selection bar only
 * exist after a click, so they are described as entries of the table step.
 */
export const VOLUNTEER_APPLICATIONS_TOUR = {
    id: 'volunteer-applications',
    version: 1,
    paths: ['staff/orders'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Your volunteer applications',
            description:
                'Every application received is listed here. The line under the title says whether applications are open and how many volunteers signed up.',
        },
        {
            key: 'tiles',
            target: '[data-tour="vol-tiles"]',
            placement: 'bottom',
            title: 'The key figures',
            description: 'Volunteers signed up, places left, cancellations and the most requested role, at a glance.',
        },
        {
            key: 'list',
            // the card's title band, not the card: a list taller than the screen leaves no room for the bubble
            target: '[data-tour="sec-orders-list"]',
            block: ':scope > .org-sec-h',
            placement: 'bottom',
            title: 'The list of applications',
            description:
                'One row per volunteer. Click a row to see the details, change the role or cancel. « Export » downloads the list.',
        },
        {
            key: 'status',
            target: '[data-tour="orders-status"]',
            placement: 'bottom',
            title: 'Confirmed or cancelled',
            description: 'These chips show only the confirmed or the cancelled applications. The numbers are live.',
        },
        {
            key: 'search',
            target: '[data-tour="orders-search"]',
            placement: 'bottom',
            title: 'Find a volunteer',
            description:
                'Search by name, email or application number, or keep one role only. « Reset filters » shows everyone again.',
        },
        {
            key: 'table',
            target: '[data-tour="sec-orders-list"] .org-tbl',
            block: 'thead',
            placement: 'bottom',
            title: 'Rows, columns and selection',
            description:
                'Click a column head to sort. Tick rows to act on several applications at once, click a row to open it.',
            entries: [
                { label: 'Selection', text: 'e-mail the volunteers, change their status or role, or export them.' },
                { label: 'Application', ns: VOLUNTEERING, text: 'number, date, status and role.' },
                { label: 'Volunteer', ns: VOLUNTEERING, text: 'identity and contact details.' },
                { label: 'Form answers', ns: VOLUNTEERING, text: 'what they answered on your form.' },
                { label: 'History', ns: VOLUNTEERING, text: 'every change made to the application.' },
            ],
        },
        {
            key: 'pager',
            target: '[data-tour="sec-orders-list"] .org-pager',
            placement: 'top',
            title: 'Page by page',
            description:
                'Choose how many rows per page and move between pages. Filters and search apply to the whole list.',
        },
    ],
}

export default VOLUNTEER_APPLICATIONS_TOUR
